import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let iso = ''

const parent = $('.js-single-faq-category-container')
if (parent.length) {
  iso = new Isotope('.js-single-faq-category-container', {
    itemSelector: '.feed-faq',
    percentPosition: true,
    transitionDuration: 0,
    masonry: {
      columnWidth: '.single-faq-category__sizer',
    },
  })

  parent.imagesLoaded(function () {
    iso.layout()
  })

  $('.js-select').on('change', function () {
    const $this = $(this)
    const val = $this.val() * 1

    if (!val) {
      iso.arrange({ filter: '*' })
      return
    }

    iso.arrange({
      filter: function () {
        const service = $(this)

        if (service.hasClass('single-faq-category__sizer')) {
          return false
        }

        const attr = service.attr('data-categories')
        const domains = attr.includes(',') ? attr.split(',') : [attr]
        const newDomains = domains.map(Number)

        return newDomains.includes(val)
      },
    })

    $this.addClass('active')
  })
}

const search = $('.js-search').keyup(
  debounce(function () {
    const regex = new RegExp(search.val(), 'gi')
    console.log(search.val())
    iso.arrange({
      filter: function () {
        const text = getTextNodesIn($(this)[0])
        return regex ? text.match(regex) : true
      },
    })
  }, 200)
)

$(document).ready(function() {
  var hash = window.location.hash;

  if (hash && hash.substring(0, 1) === '#') {
    var numero = hash.substring(1);

    var targetElement = $('#feed-faq-' + numero);
    if (targetElement.length) {
      $('html, body').animate({
        scrollTop: targetElement.offset().top
      }, 1000);

      var clickElement = targetElement.find('.feed-faq__title')
      clickElement.trigger('click');

      history.replaceState({}, document.title, window.location.pathname);
    }
  }
});
